<template>
  <BaseView>
    <div class="container">
      <!-- Barra de chats -->
      <div class="chat-bar">
        <!-- Cabecera de la barra de chats -->
        <LogoComponent />
        
        <v-btn @click="logout">Cerrar sesión</v-btn>
        
        <div style="display: none">
          <h2>Chats (proximamente)</h2>
          <!-- Lista de chats de ejemplo -->
          <ul class="chat-list">
            <li v-for="chat in fakeChats" :key="chat.id" class="chat-item">
              <div class="chat-icon skeleton"></div>
              <div class="chat-name skeleton skeleton-text"></div>
            </li>
          </ul>
        </div>
      </div>

      <h1>Tiempo restante proyectos</h1>
      <div 
        v-if="projectsList?.length > 0" 
        class="projects-container">
        <div class="projects-grid">
          <span 
            v-for="p in projectsList" 
            :key="p._id" 
            @click="this.$router.push(`/p/${p._id}/home`)"
            class="project-item">
            <TimeLeft 
              :title="p.name" 
              :startDate="p.projectDateI" 
              :endDate="p.projectDateT" 
              width="200"
              height="200"
              class="time-left"
            />
          </span>
        </div>
      </div>

      <!-- Vista central (chat abierto) -->
      <div class="central-view" style="display: none">
        <h2>Chat (proximamente)</h2>
        <!-- Título del chat o nombre del usuario -->
        <div class="skeleton skeleton-title"></div>
        <!-- Mensajes de ejemplo -->
        <div
          v-for="message in fakeMessages"
          :key="message.id"
          class="message-row"
        >
          <div class="message-avatar skeleton"></div>
          <div class="message-content">
            <div class="message-bubble skeleton">
              <div class="message-text skeleton skeleton-text"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Actividades de los usuarios -->
      <div class="activities" style="display: none">
        <h2>Perfil del chat (proximamente)</h2>
        <div class="profile-header skeleton"></div>
        <div class="profile-avatar skeleton"></div>
        <div class="profile-info">
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-text"></div>
        </div>
        <ul class="activity-list">
          <li v-for="activity in fakeActivities" :key="activity.id" class="activity-item">
            <div class="activity-icon skeleton"></div>
            <div class="activity-info skeleton skeleton-text"></div>
          </li>
        </ul>
      </div>
    </div>
  </BaseView>
</template>

<script>
import LogoComponent from "@/components/generic/LogoComponent.vue";
import BaseView from "./BaseView.vue";
import TimeLeft from "@/components/metrics/TimeLeft.vue";

export default {
  name: "HomeView",
  components: {
    LogoComponent,
    BaseView,
    TimeLeft
  },
  computed: {
    projectsList() {
      return this.$store.state.projectsList;
    },
  },
  methods: {
    logout() {
      // Borrar todo el localStorage
      localStorage.clear();
      
      // Cerrar sesión
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #f5f5f5; /* tono claro */
  overflow-y: auto;
}

/* Barra de chats */
.chat-bar {
  width: 240px;
  padding: 10px;
  background: #f5f5f5;
}

/* Lista de chats */
.chat-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.chat-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* separación entre elementos */
}

/* Contenedor de proyectos */
.projects-container {
  overflow-y: auto;
  display: flex;
  width: 100%;
  justify-content: center;
}

.projects-grid {
  display: flex;
  flex-wrap: wrap;  /* Permite que los elementos pasen a la siguiente línea si no caben */
  justify-content: center; /* Centra los elementos */
  gap: 20px; /* Espacio entre elementos */
}


/* Elemento de proyecto */
.project-item {
  justify-items: center;
  cursor: pointer;
}

/* Vista central (chat abierto) */
.central-view {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #ddd;
  background: #ffffff;
}
.message-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px; /* separación entre mensajes */
}
.message-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 10px;
}
.message-content {
  flex: 1;
}
.message-bubble {
  max-width: 70%;
  padding: 10px;
  border-radius: 10px;
  background-color: #e0e0e0;
  position: relative;
}
.message-bubble::after {
  content: "";
  position: absolute;
  top: 10px;
  left: -10px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 10px solid #e0e0e0;
  border-bottom: 10px solid transparent;
}

/* Actividades de los usuarios */
.activities {
  width: 300px;
  padding: 10px;
  background: #ffffff;
}
.activity-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.activity-item {
  display: flex;
  align-items: center;
  margin-bottom: 12px; /* separación entre actividades */
}

/* Skeletons con animación de brillo */
.skeleton {
  position: relative;
  overflow: hidden;
  background-color: #ddd; /* tono gris */
  border-radius: 4px;
}

/* Pseudo-elemento para animación shimmer */
.skeleton::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 50%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 0.4),
    rgba(255, 255, 255, 0)
  );
  animation: shimmer 1.5s infinite;
}

/* Keyframes para un brillo más pausado */
@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}

/* Tamaños de skeleton aumentados */
.skeleton-header {
  height: 30px; /* mayor altura */
  width: 70%;
  margin-bottom: 20px; /* separación entre elementos */
}
.skeleton-title {
  height: 24px; /* mayor altura */
  width: 40%;
  margin-bottom: 24px; /* separación entre elementos */
}
.skeleton-text {
  height: 18px; /* mayor altura */
  width: 100%;
  margin-bottom: 12px; /* separación entre textos */
}

/* Tamaño aumentado para íconos/avatares */
.chat-icon,
.message-avatar,
.activity-icon {
  width: 40px;  /* mayor tamaño */
  height: 40px; /* mayor tamaño */
  margin-right: 12px; /* separación entre ícono y texto */
}

/* Perfil del usuario */
.profile-header {
  height: 30px;
  width: 100%;
  margin-bottom: 20px;
}
.profile-avatar {
  height: 80px;
  width: 80px;
  border-radius: 50%;
  margin: 0 auto 20px;
}
.profile-info .skeleton-text {
  width: 80%;
  margin: 0 auto 10px;
}
</style>
